import * as Sentry from "@sentry/browser";
import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import {initReactI18next} from "react-i18next";

let language: string | undefined = document.body.dataset.lang;

if (language === undefined) {
  const err = new Error("Language code not found in DOM");
  err.name = "LanguageNotFound" + err.name;
  Sentry.captureException(err);
  language = "en";
}

function loadLocales(
  url: string,
  options: any,
  callback: (locale: {[key: string]: string} | null, status: {status: string}) => void,
) {
  import(`./locales/${url}`)
    .then((locale: {default: {[key: string]: string}}) => {
      callback(locale.default, {status: "200"});
    })
    .catch(() => {
      callback(null, {status: "404"});
    });
}

void i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    interpolation: {
      escapeValue: false, // not needed for react!!
      format(value: string, format) {
        switch (format) {
          case "uppercase":
            return value.toUpperCase();
          case "lowercase":
            return value.toLowerCase();
          default:
            return value;
        }
      },
    },
    backend: {
      ajax: loadLocales,
      loadPath: "{{lng}}/{{ns}}.json",
      parse: (data: string) => data,
    },
    defaultNS: "default",
    fallbackLng: "en",
    fallbackNS: "default",
    keySeparator: false,
    lng: language,
    ns: ["default", "cart", "checkout", "customerAccount"],
    nsSeparator: false,
    pluralSeparator: "__",
    contextSeparator: "__",
    react: {
      nsMode: "fallback",
      useSuspense: true,
      wait: true,
    },
  });

export default i18n;
